import React, { useEffect, useState } from "react";
import { PageTitle } from "../../ui/PageTitle";
import rRais from "./assets/Kamolov-1M.jpg";

import { FiPhone } from "react-icons/fi";
import { FaRegCalendarCheck } from "react-icons/fa";
import "../leaders/assets/rahbariyat.scss";
import { Image } from 'antd';
import logo from './assets/logo.gif'

import { useTranslation } from 'react-i18next';
import http from "../../ui/Services";
import { MdLanguage } from "react-icons/md";
import { urlPer } from "../../../host";
import { FaLocationDot } from "react-icons/fa6";
//@ts-ignore
function Leaders() {
  const {t} = useTranslation();
  const [loader, setLoader] = useState(true)
  const [data, setData] = useState<any>(null)
  const loaderT=()=>{
     
  }
  useEffect(()=>{
    http.get<any>(`/GetApi/Personal/3/`)
        
    .then((res) => {
      res.data.sort(function(a:any, b:any){
        if(a.branchName < b.branchName) { return -1; }
        if(a.branchName > b.branchName) { return 1; }
        return 0;
    })
      setData(res.data); setTimeout(()=>{
      setLoader(false)
  }, 0) })
    .catch(e => console.log(e))
  },[])
  return (
    <Image.PreviewGroup>
    <div className="rahbariyat" onLoad={()=>{loaderT()}}>
    {loader?<div className="loaderG">
    <div className="befG">
<img src={logo} alt="..."/>
</div>

</div>
:''}
      <div className="container">
      <PageTitle title={t('TASSARUFIDAGI TASHKILOTLAR')} />
        <div className="rahbariyat-info">
        
        {data!==null?data.map((item:any, index:any)=>{
          return(
            <div className="rahbariyat-list">
              
             <div className="content-wrapper">
             <div className="rahbariyat-list-text heigt_full" style={{display:"flex", height:'400px', padding:'0px', }}> 
              <Image className="img" src={`${urlPer}/${item.photo}`} alt="img" />
              </div>
              <div className="rahbariyat-list-text">
                <p  className="rahbariyat-list-text-position" style={{marginTop:"-2px"}}>
                  <b>
                              {t('check')?item.fullNameUz:item.fullNameRu}
                </b></p>
  
                <p  className="rahbariyat-list-text-name">
                {t('check')?item.positionUz:item.positionRu}
                </p>
                <div className="icons" style={{marginTop:'10px'}}>
                  <FaRegCalendarCheck  className="icon"  size="1.5rem" color="#244BA4" cursor="pointer"/>
                  <p  style={{position:'relative', top:'-14px'}}>{t('check')?item.openDaysUz:item.openDaysRu}</p>
                </div>
                <div className="icons">
                  <FiPhone className="icon"  size="1.5rem" color="#244BA4" cursor="pointer"/>
                  <p  style={{position:'relative', top:'-14px'}}><a href={`tel: ${item.phone}`}>{item.phone}</a></p>
                </div>
              
                <div className="web" style={{height:'40px'}}>
                <MdLanguage className="icon" size="1.5rem" color="#244BA4" cursor="pointer"/>
                <p    style={{position:'relative', top:'-14px'}}><a href={`https://www.${item.webSite}`}>{item.webSite}</a></p>
              </div>
              <div className="icons" style={{marginTop:'5px', marginBottom:'20px'}}>
                              <FaLocationDot className="icon" size="1.5rem" color="#244BA4" cursor="pointer"/>
                              <p style={{position:'relative', top:'-14px'}}>{t("lang")==='uz'?item.organizationAddressUz:item.organizationAddressRu}</p>
                            </div>
              </div>
              </div> 
            </div>
          )
        }):''}
        
        
        </div>
      </div>
    </div>
    </Image.PreviewGroup>
  );
}

export default Leaders;
